<script setup lang="ts">
import { SortedWorkingHours } from '@/store/city/city.types'

type Props = {
  sortedWorkingTours: SortedWorkingHours[]
}

const props = defineProps<Props>()

const workingHoursList = props.sortedWorkingTours.map(
  ({ badge, start, end, is_working }) => {
    if (!is_working) return `${badge} выходной`

    return `${badge} c ${start} до ${end}`
  },
)
</script>

<template>
  <div class="header-working-hours-list" data-testid="work-list">
    <ul>
      <li v-for="day in workingHoursList" :key="day">
        {{ day }}
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.header-working-hours-list {
  width: max-content;

  ul {
    padding: 0;
    list-style-type: none;
  }

  li {
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    color: var(--ui-white);

    &:not(:last-child) {
      margin-bottom: 8px;
    }
  }
}
</style>
